<template>
  <div style="border-radius: 8px" class="row">
    <div class="row">
      <div class="card p-2 pb-0 filter col-md-12">
        <div class="row align-items-end w-100 py-2">

          <div class="col-md-3 col-12">
            <label class="form-label">Quantity</label>
            <input
                v-model="sticker.quantity"
                class="form-control"
                type="number"
                min="1"
            />
          </div>

          <div class="col-md-4 col-12">
            <div class="d-flex gap-2 flex-wrap">
              <div class="form-check">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="productName"
                    v-model="sticker.show_product_name"
                />
                <label class="form-check-label" for="productName">
                  Product Name
                </label>
              </div>

              <div class="form-check">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="companyName"
                    v-model="sticker.show_company_name"
                />
                <label class="form-check-label" for="companyName">
                  Company Name
                </label>
              </div>

              <div class="form-check">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="price"
                    v-model="sticker.show_price"
                />
                <label class="form-check-label" for="price">
                  Price
                </label>
              </div>

            </div>
          </div>

          <div class="col-md-3 col-12">
            <button @click="goToPrint" class="btn btn-primary mt-1">Print</button>
          </div>

        </div>
        <div class="col-md-12">
          <div id="section-to-print">
            <div class="row gap-1">
              <div v-for="index in barcodeQty" :key="index" class="sticker-border text-center loop-dev">
                <div class="l-height">
                  <span class="text-label" v-if="sticker.show_company_name && productData.company_name">{{ productData.company_name }}</span>
                  <span class="text-label" v-if="sticker.show_product_name && productData.name">{{ productData.name }}</span>
                  <div class="barcode-img d-flex justify-content-center align-items-center" v-html="barcode"></div>
                  <span class="text-label">{{ productData.barcode_sku }}</span>
                  <span class="text-label" v-if="sticker.show_price && productData.description &&  productData.description.sales_price">MRP: {{ productData.description.sales_price }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loader v-if="loading"/>

  </div>
</template>

<script setup>

import {computed, inject, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import handleBarcode from "@/services/modules/barcode";
import { printBarcodes } from '@/services/utils/pdf/barcodePrint.js';
import handleInventory from '@/services/modules/inventory'
import Loader from '@/components/atom/LoaderComponent';

const { fetchBarcode } = handleBarcode();
const route = useRoute();

const barcodeQty = computed(() => parseInt(sticker.value.quantity));
const { getProduct } = handleInventory()
let barcode = ref(null);
let loading = ref(false);
let productData = ref({});
let sticker = ref({
  quantity: 1,
  show_product_name: true,
  show_company_name: true,
  show_price: true,
});
const showError = inject('showError');
const showSuccess = inject('showSuccess');

const getBarCode = (code) => {
  fetchBarcode(`?code=${code}&width=1&height=40&type=C128`).then((res) => {
    barcode.value = res.barcode;
  })
}

const fetchSingleProduct = async (id) => {
  try {
    loading.value = true
    let res = await getProduct({id: id, company_id: route.params.companyId})
    if(!res.status) {
      showError(res.message)
    }

    productData.value = res.data
    getBarCode(productData.value.barcode_sku)
  } catch (err) {
    showError('Something is wrong. Check your connectivity!!')
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  if (route.params.productId) {
    fetchSingleProduct(route.params.productId)
  }
})

const goToPrint = () => {
  if (productData.value && !productData.value.id){
    showError("Product Not Found")
    return
  }
  printBarcodes({
    barcodeHtml: barcode.value,
    quantity: parseInt(sticker.value.quantity),
    data: productData.value,
    options: {
      show_product: sticker.value.show_product_name,
      show_company: sticker.value.show_company_name,
      show_price: sticker.value.show_price,
    }
  });
}
</script>

<style>
.text-center {
  text-align: center;
}

.loop-dev {
  height: auto;
  padding-bottom: 5px;
  margin-bottom: 10px;
  line-height: 1.0000in;
  width: auto;
  display: block;
}

.text-label {
  font-size: 14px;
  display: block;
  margin: 3px
}

/*Css related to printing of barcode*/
.label-border-outer {
  line-height: 16px;
  page-break-after: always;
  border: 0.1px solid grey !important;
}

.label-border-internal {
  margin: 24px;
}

.sticker-border {
  border: 0.1px dotted grey !important;
  overflow: hidden;
  box-sizing: border-box;
}

.barcode-img svg {
  display: block;
  height: auto;
}

.fixed-width-name {
  width: 140px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.l-height {
  line-height: 15px;
}
</style>
